import { useMutation, useQueryClient } from '@tanstack/react-query';
import { I18n } from '@aws-amplify/core';
import { message } from 'antd';

import { KimLhcService } from '@/infra/services/kim-lhc';
import { QUERY_KEYS } from '@/utils/query-keys';

interface ConsolidateKimLhcReportParams {
	id: string;
	organization_id: string;
	company_id: string;
	locale: string;
	consolidated: boolean;
}

const Service = KimLhcService.getInstance();

export const useConsolidateKimLhcReport = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: ConsolidateKimLhcReportParams) => Service.consolidate(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_KIM_LHC_RESULT]);
			message.success(I18n.get('Report updated successfully'));
		},
		onError: () => {
			message.error(I18n.get('Failed to update report'));
		}
	});
};
